<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col>
          <h1>Uber Eats Tiendas</h1>
        </b-col>
        <b-col cols="auto">
          <b-button variant="warning" size="sm" class="my-3" @click="showBulkMenuModal">Enviar Múltiples Menús</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group label="Buscar tienda:">
            <b-form-input v-model="search" placeholder="Buscar por nombre..." debounce="300"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      

      <b-row>
        <b-col xs="12" sm="6" md="4" lg="3" xl="3" v-for="sucursal in filteredStores" v-bind:key="sucursal.id">
          <b-card class="mb-3">
            <b-card-body class="p-1">
              <h6 class="card-title mb-2">{{ sucursal.nombre }}</h6>
              <p class="card-text small mb-2">
                <strong>Código:</strong> {{ sucursal.code }}<br>
                <strong>ID Uber:</strong> {{ sucursal.uber_store_id || 'N/A' }}<br>
                <strong>Menu:</strong> {{ sucursal.uber_menu_id || 'N/A' }}
              </p>
              <div class="d-flex flex-column gap-1">
                <b-button size="sm" :disabled="!sucursal.status || !sucursal.uber_store_id" variant="success" block
                  @click="sendUberMenu(sucursal.id)">Enviar Menu</b-button>
                <b-button size="sm" variant="outline-info" block @click="showUberDetails(sucursal)">Detalles</b-button>
              </div>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      
      <!-- Uber Details Modal -->
      <b-modal id="uber-details-modal" :title="'Detalles Uber Eats - ' + selectedStore.nombre" size="lg" @hidden="resetModalData">
        <div v-if="selectedStore.uber_store_id && selectedStore.uber_store_id.length > 0">
          <b-row class="mb-3">
            <b-col>
              <h5>Información General</h5>
              <p>
                Nombre: {{ uberInfo.name }}<br>
                ID Uber: {{ uberInfo.store_id }}<br>
                Dirección: {{ uberInfo.location.address }}<br>
                Status: {{ uberInfo.status }}<br>
                Tiempo Promedio Prep: {{ uberInfo.avg_prep_time }}<br>
                Url web: <a :href="uberInfo.web_url" target="_blank">{{ uberInfo.web_url }}</a>
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col>
              <h5>Integración</h5>
              <p>
                Auto Aceptación: <b-icon v-if="uberIntegrationInfo.auto_accept_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Integración Habilitada: <b-icon v-if="uberIntegrationInfo.integration_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon><br>
                Status Online: {{ uberIntegrationInfo.online_status }}<br>
                POS Integración: <b-icon v-if="uberIntegrationInfo.pos_integration_enabled" icon="check-square" variant="success"></b-icon> <b-icon v-else icon="x-circle" variant="danger"></b-icon>
              </p>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col>
              <h5>Estado de la tienda</h5>
              <p class="mb-2">
                <strong>Status actual:</strong>
                <b-badge :variant="uberStoreStatusBadgeVariant" class="ml-1">
                  {{ uberStoreStatusLabel }}
                </b-badge>
                <span v-if="uberStoreStatus.offlineReason" class="ml-2 text-muted small">
                  Razón: {{ uberStoreStatus.offlineReason }}
                </span>
                <span v-if="uberStoreStatus.paused_until" class="ml-2 text-muted small">
                  Hasta: {{ uberStoreStatus.paused_until }}
                </span>
              </p>
              <b-form-group label="Razón (opcional al cerrar):" label-class="small">
                <b-form-input v-model="closeReason" size="sm" placeholder="Ej. Falta de personal"></b-form-input>
              </b-form-group>
              <b-button-group size="sm">
                <b-button
                  variant="success"
                  :disabled="updatingStatus"
                  @click="setUberStoreStatus(selectedStore.uber_store_id, true)"
                >
                  <b-icon icon="play-circle"></b-icon> Abrir tienda
                </b-button>
                <b-button
                  variant="danger"
                  :disabled="updatingStatus"
                  @click="setUberStoreStatus(selectedStore.uber_store_id, false)"
                >
                  <b-icon icon="pause-circle"></b-icon> Cerrar tienda
                </b-button>
              </b-button-group>
              <b-spinner v-if="updatingStatus" small class="ml-2"></b-spinner>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button variant="primary" @click="refreshUberInfo(selectedStore.uber_store_id)">Actualizar Info</b-button>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <b-alert show variant="warning">Esta tienda no tiene configuración de Uber Eats</b-alert>
        </div>
      </b-modal>
      
      <!-- Bulk Menu Send Modal -->
      <b-modal id="bulk-menu-modal" title="Enviar Menús Múltiples" size="lg" @ok="sendBulkMenus">
        <b-form-group label="Seleccionar tiendas:">
          <div style="max-height: 300px; overflow-y: auto;">
            <b-form-checkbox-group v-model="selectedStores" :options="storeOptions" stacked></b-form-checkbox-group>
          </div>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox v-model="selectAll" @change="toggleSelectAll">Seleccionar todas</b-form-checkbox>
        </b-form-group>
        <p><strong>{{ selectedStores.length }}</strong> tiendas seleccionadas</p>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
export default {
  name: "UberStores",
  components: { Nav },
  data() {
    return {
      storesOnline: 0,
      storesOffline: 0,
      storesTable: [],
      search: "",
      selectedStore: {},
      selectedStores: [],
      selectAll: false,
      storeOptions: [],
      uberInfo: {
        name: "",
        store_id: "",
        location: {
          address: ""
        },
        avg_prep_time: 0,
        status: "",
        web_url: ""
      },
      uberIntegrationInfo: {
        auto_accept_enabled: false,
        integration_enabled: false,
        online_status: "",
        pos_integration_enabled: false
      },
      uberStoreStatus: {
        status: "",
        offlineReason: "",
        paused_until: ""
      },
      closeReason: "",
      updatingStatus: false
    };
  },
  computed: {
    filteredStores() {
      if (!this.search) return this.storesTable;
      return this.storesTable.filter(store =>
        store.nombre.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    uberStoreStatusLabel() {
      return this.uberStoreStatus.status || "Desconocido";
    },
    uberStoreStatusBadgeVariant() {
      const s = (this.uberStoreStatus.status || "").toUpperCase();
      if (s === "ONLINE") return "success";
      if (s === "OFFLINE" || s === "PAUSED") return "danger";
      return "secondary";
    }
  },
  created() {
    this.getAllUberStores();
  },
  methods: {
    getAllUberStores() {
      let that = this;
      axios
        .get("/sucursals")
        .then(function (response) {
          that.storesTable = response.data
            .filter(store => store.uber_store_id != null)
            .sort((a, b) => a.nombre.localeCompare(b.nombre));
          
          that.storesOnline = that.storesTable.filter(x => x.uber_status === 'ONLINE').length;
          that.storesOffline = that.storesTable.filter(x => x.uber_status === 'OFFLINE').length;
          
          that.storeOptions = that.storesTable
            .filter(store => store.status && store.uber_store_id)
            .map(store => ({ value: store.id, text: store.nombre }));
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    sendUberMenu(sucursal_id) {
      let that = this;
      axios
        .put("/sucursal/" + sucursal_id + "/uber/uploadmenu", null)
        .then(function () {
          that.makeToast("Exito", "Menu enviado exitosamente", "success");
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    showUberDetails(store) {
      this.selectedStore = store;
      if (store.uber_store_id && store.uber_store_id.length > 0) {
        this.getUberInfo(store.uber_store_id);
      }
      this.$bvModal.show('uber-details-modal');
    },
    getUberInfo(storeId) {
      let that = this;
      axios
        .get("/uber/store/" + storeId + "/info")
        .then(function (response) {
          that.uberInfo = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });

      axios
        .get("/uber/store/" + storeId + "/integration/status")
        .then(function (response) {
          that.uberIntegrationInfo = response.data;
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });

      axios
        .get("/uber/store/" + storeId + "/status")
        .then(function (response) {
          that.uberStoreStatus = response.data || {};
        })
        .catch(function (err) {
          that.makeToast("Error", err.request.response, "danger");
        });
    },
    refreshUberInfo(storeId) {
      this.getUberInfo(storeId);
      this.makeToast("Info", "Información actualizada", "info");
    },
    setUberStoreStatus(storeId, isOnline) {
      const action = isOnline ? "abrir" : "cerrar";
      this.$bvModal
        .msgBoxConfirm(`¿Confirmas ${action} la tienda en Uber Eats?`, {
          title: "Confirmar cambio de status",
          okVariant: isOnline ? "success" : "danger",
          okTitle: isOnline ? "Abrir" : "Cerrar",
          cancelTitle: "Cancelar",
          centered: true,
        })
        .then((ok) => {
          if (!ok) return;
          this.updatingStatus = true;
          let that = this;
          axios
            .put("/uber/store/" + storeId + "/status", {
              is_online: isOnline,
              reason: isOnline ? "" : that.closeReason,
            })
            .then(function (res) {
              that.makeToast(
                "Exito",
                "Tienda " + (isOnline ? "abierta" : "cerrada") + " (" + (res.data && res.data.status ? res.data.status : "ok") + ")",
                "success"
              );
              that.closeReason = "";
              that.getUberInfo(storeId);
            })
            .catch(function (err) {
              that.makeToast("Error", err.request ? err.request.response : err.message, "danger");
            })
            .finally(function () {
              that.updatingStatus = false;
            });
        });
    },
    showBulkMenuModal() {
      this.selectedStores = [];
      this.selectAll = false;
      this.$bvModal.show('bulk-menu-modal');
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedStores = this.storeOptions.map(option => option.value);
      } else {
        this.selectedStores = [];
      }
    },
    async sendBulkMenus() {
      if (this.selectedStores.length === 0) {
        this.makeToast("Advertencia", "Selecciona al menos una tienda", "warning");
        return;
      }
      
      let successCount = 0;
      let errorCount = 0;
      
      for (let storeId of this.selectedStores) {
        try {
          await axios.put("/sucursal/" + storeId + "/uber/uploadmenu", null);
          successCount++;
          const store = this.storesTable.find(s => s.id === storeId);
          this.makeToast("Exito", `Menu enviado: ${store ? store.nombre : storeId}`, "success");
        } catch (err) {
          errorCount++;
          const store = this.storesTable.find(s => s.id === storeId);
          this.makeToast("Error", `Error en: ${store ? store.nombre : storeId} ${err.request.response}`, "danger");
        }
      }
      
      this.makeToast("Completado", `Proceso terminado. Exitosos: ${successCount}, Errores: ${errorCount}`, "info");
    },
    resetModalData() {
      this.selectedStore = {};
      this.uberInfo = {
        name: "",
        store_id: "",
        location: {
          address: ""
        },
        avg_prep_time: 0,
        status: "",
        web_url: ""
      };
      this.uberIntegrationInfo = {
        auto_accept_enabled: false,
        integration_enabled: false,
        online_status: "",
        pos_integration_enabled: false
      };
      this.uberStoreStatus = { status: "", offlineReason: "", paused_until: "" };
      this.closeReason = "";
    },
    makeToast(title, content, variant) {
      this.$bvModal.msgBoxOk(content, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      });
    }
  }
};
</script>